import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ListItem } from '@models/models';

@Component({
	selector: 'template-apply-group-list',
	template: require('./template-apply-group-list.component.html'),
	styles: [require('./template-apply-group-list.component.scss')]
})
export class TemplateApplyGroupListComponent {
	@Input() text: string;
	@Input() idField = 'id';
	@Input() defaultOptionName = 'None';
	@Input() templateList: Array<ListItem>;
	@Input() templateDefaultList: Array<ListItem>;
	@Input() disabled: boolean;
	@Input() selectedTemplateId: string;
	@Input() disablePlaceholder: boolean;
	@Input() label: string;
	@Output() onTemplateChange: EventEmitter<string> = new EventEmitter();

	onChange(event): void {
		this.onTemplateChange.emit(event);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./web/modern/components/quote/common/payment-shedule-template-group-list/template-apply-group-list.component.ts